const PLANTMFGDIRECTOR="plant_mfg_director"
const PLANTSPECIALIST="plant_specialist"

const PLANT_MFG_DIRECTOR="Plant Mfg Director"
const PLANT_SPECIALIST="Plant Specialist"
export default {
    PLANT_MFG_DIRECTOR: PLANT_MFG_DIRECTOR,
    PLANT_SPECIALIST:PLANT_SPECIALIST,
}